import GetSources from '@/services/canvassers/sourceService/GetSources';

export default class SourceService {
    /**
     * Get canvasser sources.
     *
     * @param {Number|null} parentId
     *
     * @returns {Promise}
     */
    getSources(parentId = null) {
        return (new GetSources()).handle(parentId);
    }
}
